// ! AUTO-GENERATED FILE
// ! DO NOT TOUCH !!!

// #pause-sonar#
import { HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import {
  createSupplierCondition,
  CreateSupplierCondition$Params,
} from '../fn/supplier-condition/create-supplier-condition';
import {
  deleteSupplierConditionById,
  DeleteSupplierConditionById$Params,
} from '../fn/supplier-condition/delete-supplier-condition-by-id';
import {
  findAllSupplierConditions,
  FindAllSupplierConditions$Params,
} from '../fn/supplier-condition/find-all-supplier-conditions';
import {
  findSupplierConditionById,
  FindSupplierConditionById$Params,
} from '../fn/supplier-condition/find-supplier-condition-by-id';
import {
  updateSupplierCondition,
  UpdateSupplierCondition$Params,
} from '../fn/supplier-condition/update-supplier-condition';
import { CreateSupplierConditionRestResponse } from '../models/create-supplier-condition-rest-response';
import { RetrieveSupplierConditionsRestResponse } from '../models/retrieve-supplier-conditions-rest-response';
import { UpdateSupplierConditionRestResponse } from '../models/update-supplier-condition-rest-response';
import { StrictHttpResponse } from '../strict-http-response';

@Injectable({ providedIn: 'root' })
export class SupplierConditionService extends BaseService {
  /** Path part for operation `findSupplierConditionById()` */
  static readonly FindSupplierConditionByIdPath = '/supplier-condition/{id}';

  /**
   * Get supplier condition by ID.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findSupplierConditionById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findSupplierConditionById$Response(
    params: FindSupplierConditionById$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<RetrieveSupplierConditionsRestResponse>> {
    return findSupplierConditionById(this.http, this.rootUrl, params, context);
  }

  /**
   * Get supplier condition by ID.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findSupplierConditionById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findSupplierConditionById(
    params: FindSupplierConditionById$Params,
    context?: HttpContext,
  ): Observable<RetrieveSupplierConditionsRestResponse> {
    return this.findSupplierConditionById$Response(params, context).pipe(
      map(
        (r: StrictHttpResponse<RetrieveSupplierConditionsRestResponse>): RetrieveSupplierConditionsRestResponse =>
          r.body,
      ),
    );
  }

  /** Path part for operation `updateSupplierCondition()` */
  static readonly UpdateSupplierConditionPath = '/supplier-condition/{id}';

  /**
   * Update existing supplier condition.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSupplierCondition()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSupplierCondition$Response(
    params: UpdateSupplierCondition$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<UpdateSupplierConditionRestResponse>> {
    return updateSupplierCondition(this.http, this.rootUrl, params, context);
  }

  /**
   * Update existing supplier condition.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSupplierCondition$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSupplierCondition(
    params: UpdateSupplierCondition$Params,
    context?: HttpContext,
  ): Observable<UpdateSupplierConditionRestResponse> {
    return this.updateSupplierCondition$Response(params, context).pipe(
      map((r: StrictHttpResponse<UpdateSupplierConditionRestResponse>): UpdateSupplierConditionRestResponse => r.body),
    );
  }

  /** Path part for operation `deleteSupplierConditionById()` */
  static readonly DeleteSupplierConditionByIdPath = '/supplier-condition/{id}';

  /**
   * Delete existing supplier condition.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteSupplierConditionById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSupplierConditionById$Response(
    params: DeleteSupplierConditionById$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<void>> {
    return deleteSupplierConditionById(this.http, this.rootUrl, params, context);
  }

  /**
   * Delete existing supplier condition.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteSupplierConditionById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteSupplierConditionById(params: DeleteSupplierConditionById$Params, context?: HttpContext): Observable<void> {
    return this.deleteSupplierConditionById$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body),
    );
  }

  /** Path part for operation `findAllSupplierConditions()` */
  static readonly FindAllSupplierConditionsPath = '/supplier-condition';

  /**
   * Get all supplier conditions.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findAllSupplierConditions()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllSupplierConditions$Response(
    params?: FindAllSupplierConditions$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<Array<RetrieveSupplierConditionsRestResponse>>> {
    return findAllSupplierConditions(this.http, this.rootUrl, params, context);
  }

  /**
   * Get all supplier conditions.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `findAllSupplierConditions$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findAllSupplierConditions(
    params?: FindAllSupplierConditions$Params,
    context?: HttpContext,
  ): Observable<Array<RetrieveSupplierConditionsRestResponse>> {
    return this.findAllSupplierConditions$Response(params, context).pipe(
      map(
        (
          r: StrictHttpResponse<Array<RetrieveSupplierConditionsRestResponse>>,
        ): Array<RetrieveSupplierConditionsRestResponse> => r.body,
      ),
    );
  }

  /** Path part for operation `createSupplierCondition()` */
  static readonly CreateSupplierConditionPath = '/supplier-condition';

  /**
   * Create new supplier condition.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createSupplierCondition()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSupplierCondition$Response(
    params: CreateSupplierCondition$Params,
    context?: HttpContext,
  ): Observable<StrictHttpResponse<CreateSupplierConditionRestResponse>> {
    return createSupplierCondition(this.http, this.rootUrl, params, context);
  }

  /**
   * Create new supplier condition.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `createSupplierCondition$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createSupplierCondition(
    params: CreateSupplierCondition$Params,
    context?: HttpContext,
  ): Observable<CreateSupplierConditionRestResponse> {
    return this.createSupplierCondition$Response(params, context).pipe(
      map((r: StrictHttpResponse<CreateSupplierConditionRestResponse>): CreateSupplierConditionRestResponse => r.body),
    );
  }
}

// #continue-sonar#
